import { MruCache } from 'owa-mru-cache';
import type ConversationItemParts from './schema/ConversationItemParts';

const cacheSize = 50;
/* eslint-disable-next-line owa-custom-rules/no-side-effects -- (https://aka.ms/OWALintWiki)
 * Baseline. DO NOT COPY AND PASTE!, replace this line with a justification or fix the issue.
 *	> Function MruCache called at module scope is not allowed. This may cause unwanted side effects. */
const conversationCache: MruCache<ConversationItemParts> = new MruCache<ConversationItemParts>(
    'ConversationItemParts',
    cacheSize
);
export default conversationCache;
export function getConversationCache(): MruCache<ConversationItemParts> {
    return conversationCache;
}
